'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';

type Props = {
  intent: 'trial' | 'demo' | 'whatsapp';
  buttonLabel: string;
};

export default function AdvocateLeadForm({ intent, buttonLabel }: Props) {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function submit(formData: FormData) {
    setLoading(true);
    setError('');
    const payload = {
      name: String(formData.get('name') || ''),
      email: String(formData.get('email') || ''),
      mobile: String(formData.get('mobile') || ''),
      city: String(formData.get('city') || ''),
      court: String(formData.get('court') || ''),
      activeCases: String(formData.get('activeCases') || ''),
      whatsappOptIn: formData.get('whatsappOptIn') === 'on',
      intent,
      source: intent === 'demo' ? 'demo_page' : intent === 'whatsapp' ? 'whatsapp_demo_page' : 'advocates_page',
      pageUrl: window.location.href,
      attribution: Object.fromEntries(new URLSearchParams(window.location.search).entries()),
    };
    const res = await fetch('/api/marketing/leads', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    setLoading(false);
    if (!res.ok) {
      setError(data.error || 'Could not submit. Please check the details.');
      return;
    }
    router.push(data.nextUrl || '/thank-you');
  }

  return (
    <form action={submit} className="grid gap-3 rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
      <div className="grid gap-3 md:grid-cols-2">
        <input name="name" placeholder="Name" className="rounded-lg border px-3 py-2" />
        <input name="email" type="email" placeholder="Email" className="rounded-lg border px-3 py-2" />
        <input name="mobile" placeholder="Mobile" className="rounded-lg border px-3 py-2" />
        <input name="city" placeholder="City" className="rounded-lg border px-3 py-2" />
        <input name="court" placeholder="Main court" className="rounded-lg border px-3 py-2" />
        <input name="activeCases" placeholder="Active cases" className="rounded-lg border px-3 py-2" />
      </div>
      <label className="flex gap-3 rounded-lg bg-gray-50 p-3 text-sm text-gray-700">
        <input name="whatsappOptIn" type="checkbox" className="mt-1" />
        <span>I agree to receive demo, onboarding, and product updates from India Case Status on WhatsApp. I can opt out anytime by replying STOP.</span>
      </label>
      {error && <p className="rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
      <button disabled={loading} className="rounded-lg bg-blue-700 px-4 py-3 font-semibold text-white disabled:opacity-60">
        {loading ? 'Submitting...' : buttonLabel}
      </button>
    </form>
  );
}
